/**
 * Per-account email signatures for compose / reply.
 * Signatures are stored on EmailAccount and cached in localStorage.
 */

export function accountRecordId(acc) {
  return String(acc?.id || acc?._id || "");
}

export function findAccountById(accounts, id) {
  const sid = String(id || "");
  if (!sid) return null;
  return (accounts || []).find((a) => accountRecordId(a) === sid) || null;
}

export function readCachedEmailSignature(accountId) {
  try {
    const cached = JSON.parse(localStorage.getItem("emailSignatures") || "{}");
    const sid = String(accountId || "");
    if (Object.prototype.hasOwnProperty.call(cached, sid)) {
      return cached[sid] || "";
    }
    const key = Object.keys(cached).find((k) => String(k) === sid);
    return key != null ? cached[key] || "" : null;
  } catch {
    return null;
  }
}

/**
 * Resolve the signature for an account without a network call.
 * Returns a string when known (including "") or null when still unknown.
 */
export function signatureForAccount(accounts, accountId) {
  const acc = findAccountById(accounts, accountId);
  const fromAccount =
    acc && typeof acc.emailSignature === "string" ? acc.emailSignature : null;
  if (fromAccount && fromAccount.trim()) return fromAccount;
  const cached = readCachedEmailSignature(accountId);
  if (cached && String(cached).trim()) return cached;
  if (fromAccount != null) return fromAccount;
  return cached;
}

export function editorLooksEmpty(editor) {
  if (!editor) return true;
  const html = editor.innerHTML || "";
  return (
    !html ||
    html === "<br>" ||
    html === "<div><br></div>" ||
    !html.replace(/<[^>]*>/g, "").trim()
  );
}

export function composePlainWithoutSignature(html) {
  const doc = document.createElement("div");
  doc.innerHTML = html || "";
  doc.querySelectorAll(".email-signature-block").forEach((node) => node.remove());
  return (doc.textContent || "").replace(/\u00a0/g, " ").trim();
}

export function applyEmailSignatureToEditor(editor, signatureText) {
  if (!editor) return false;
  editor.querySelectorAll(".email-signature-block").forEach((el) => el.remove());
  const text = signatureText == null ? "" : String(signatureText);
  if (!text.trim()) return true;
  const sigHtml = `<div class="email-signature-block" style="color:#555;margin-top:12px;">${text.replace(/\n/g, "<br>")}</div>`;
  const currentContent = editor.innerHTML || "";
  const isEmpty =
    !currentContent ||
    currentContent === "<br>" ||
    currentContent === "<div><br></div>" ||
    !currentContent.replace(/<[^>]*>/g, "").trim();
  if (isEmpty) {
    editor.innerHTML = `<div><br></div>${sigHtml}`;
  } else {
    editor.insertAdjacentHTML("beforeend", sigHtml);
  }
  return true;
}
